import BaseMixpanelTracker from './base.mixpanel-tracker'
import Utils from '@/util'
import { EVENT_CATEGORIES_BY_ROUTE_NAME } from '@/constant/routes'
import { CREATE_NEW_SLIDE } from '@/constant/eventActions/PresentationsEventActions'

class SlideMixpanelTracker extends BaseMixpanelTracker {
  constructor(presentation, routeName) {
    super(presentation)
    this.routeName = routeName
  }

  trackCreateNewSlide(eventLabel, eventValue, useGA4Tracking) {
    const eventAction = CREATE_NEW_SLIDE
    const eventCategory = EVENT_CATEGORIES_BY_ROUTE_NAME[this.routeName]
    const { aiGeneratedSlideCount, importedFileAIGeneratedSlideCount } = this.presentation

    const presentationContainsAIGeneratedSlides =
      ((aiGeneratedSlideCount && aiGeneratedSlideCount > 0) ||
      (importedFileAIGeneratedSlideCount && importedFileAIGeneratedSlideCount > 0)) ||
      false

    const trackingCustomProps = {
      ...this.getCustomProps(),
      presentationContainsAIGeneratedSlides,
    }

    if (useGA4Tracking) {
      const trackData = {
        eventAction,
        eventCategory,
        eventLabel,
        eventValue,
        ...trackingCustomProps,
      }
      Utils.trackGA4AndMixpanel(eventAction, trackData)
    } else {
      Utils.mixpanelTracking(eventCategory, eventAction, eventLabel, eventValue, trackingCustomProps)
    }
  }
}

export default SlideMixpanelTracker
